module.exports = __webpack_public_path__ + "img/scene-service.003ee922.jpg";